import { levenshtein, normalize } from './text.ts';

export type TypedVerdict = 'correct' | 'almost' | 'wrong';

/**
 * Sprawdza słowo wpisane przez dziecko.
 * - 'correct': identyczne po normalizacji (wielkość liter i interpunkcja nie mają znaczenia)
 * - 'almost' : jedna literówka w słowie o długości >= 4 (dajemy drugą szansę)
 * - 'wrong'  : reszta
 */
export function checkTyped(expected: string, typed: string): TypedVerdict {
  const e = normalize(expected);
  const t = normalize(typed);
  if (t === '') return 'wrong';
  if (e === t) return 'correct';
  if (e.length >= 4 && levenshtein(e, t) <= 1) return 'almost';
  return 'wrong';
}

/** Zdanie z luką w miejscu słówka: "I want ____." (zachowuje interpunkcję i wielkość liter reszty). */
export function blankOut(sentence: string, word: string): string {
  const re = new RegExp(`\\b${word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'i');
  return sentence.replace(re, '_____');
}
